// Table column width constants for tickets table
export const TICKET_TABLE_WIDTHS = {
  ACTION: 200,
  STATUS: 100,
  WEB: 100,
  MATCH: {
    DESKTOP: 230,
    MOBILE: 150,
  },
  TYPE: {
    DESKTOP: 160,
    MOBILE: 100,
  },
  EVENT_NAME: 200,
  REVENUE: {
    DESKTOP: 160,
    MOBILE: 100,
  },
  QUANTITY: {
    DESKTOP: 160,
    MOBILE: 100,
  },
  CHECKINS: {
    DESKTOP: 160,
    MOBILE: 100,
  },
  PRICE: 200,
  EVENT_DATE: 150,
  SALE_END_DATE: {
    DESKTOP: 160,
    MOBILE: 100,
  },
  EVENT_CODE: 150,
};

// Table column width constants for ticket details tables
export const TICKET_DETAILS_WIDTHS = {
  PURCHASER_NAME: 300,
  TICKET: 300,
  QUANTITY: 150,
  CHECKED_IN: 150,
  REVENUE: 150,
  PURCHASE_DATE: 175,
  PURCHASE_TIME: 175,
  PURCHASER_EMAIL: 300,
  ATTENDEES: 300,
  NUMBER: 100,
};

// Helper function to get responsive width
export const getResponsiveWidth = (
  widthConfig,
  isDesktop = window.screen.width > 500
) => {
  if (typeof widthConfig === "number") {
    return widthConfig;
  }
  return isDesktop ? widthConfig.DESKTOP : widthConfig.MOBILE;
};
